import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade';
import { selectTotal, useFetchCalendarAccountsQuery, useFetchMetadataQuery } from 'features/calendar_connections';
import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context';
import { useLocalStorageAlerts } from 'hooks/use_local_storage_alerts';
import { ActiveCalendarConnections } from './active_calendar_connections';
import { ConnectCalendar } from './connect_calendar';
import { CALENDAR_CONNECTIONS_POPUP_ROUTE } from './constants';
import { CalendarAccountPopup } from './integration_provider';
import { PushCalendars } from './integration_provider/push_calendars';
const contentContainerCss = "c7xiig8";
const accountCalendarsCss = "a1v12dei";
const titleBlockCss = "tatamkt";
const addButtonCellCss = "a9tx0c3";
const fullWidthCss = "fsh1pxb";
const AddCalendarAccountButton = props => <Button {...props} appearance="secondary-outline" responsive={false} size="small">
    <AddMiniIcon />
    {' '}
    {I18n.t('publisher.availability_page.calendar_settings.connect_calendar_account')}
  </Button>;
export const CalendarSettings = () => {
  const history = useHistory();
  const isSettingsModalLayout = useIsSettingsModalLayout();
  const {
    data,
    isLoading: isAccountsLoading,
    isSuccess
  } = useFetchCalendarAccountsQuery();
  const {
    data: {
      accountTotalLimit
    } = {},
    isLoading: isMetadataLoading
  } = useFetchMetadataQuery();
  const connectionsCount = isSuccess ? selectTotal(data) : 0;
  const hasConnections = connectionsCount > 0;
  const canAddAccount = hasConnections && connectionsCount < accountTotalLimit;
  useLocalStorageAlerts();
  const nonConfiguredOutlookDesktopAccount = data ? Object.values(data.entities || {}).find(({
    kind,
    outlookDesktopConfigured
  }) => !outlookDesktopConfigured && kind === 'outlook_desktop') : undefined;
  const enforceUpgrade = useEnforceUpgrade('multiple_calendar_connections', {
    paywall: 'general_calendar_connections_add_calendar'
  });
  const handleAddCalendarClick = () => {
    enforceUpgrade(() => history.push(CALENDAR_CONNECTIONS_POPUP_ROUTE.newPath));
  };
  useEffect(() => {
    if (nonConfiguredOutlookDesktopAccount?.uuid) {
      history.replace(CALENDAR_CONNECTIONS_POPUP_ROUTE.getOutlookDesktopEditPath(nonConfiguredOutlookDesktopAccount.uuid));
    }
  }, [nonConfiguredOutlookDesktopAccount, history]);
  if (isAccountsLoading || isMetadataLoading) return <Loader size="small" />;
  const title = <TitleText level={3} size="small">
      {I18n.t('publisher.availability_page.calendar_settings.check_conflicts.title')}
    </TitleText>;
  const description = <BodyText>
      {I18n.t('publisher.availability_page.calendar_settings.check_conflicts.description')}
    </BodyText>;

  // The container needs a role="region" for monolith feature spec testing
  // Selector is referenced in spec/features/availability_page/calendar_settings/connect_calendar_modal_spec.rb
  return <div role="region" className={contentContainerCss}>
      <div className={accountCalendarsCss}>
        {hasConnections ? <div className={titleBlockCss}>
            {title}
            {description}
          </div> : <div className={fullWidthCss}>{description}</div>}
        {canAddAccount ? <div className={addButtonCellCss}>
            <AddCalendarAccountButton onClick={handleAddCalendarClick} />
          </div> : null}
        <div className={fullWidthCss}>
          {hasConnections ? <ActiveCalendarConnections /> : <ConnectCalendar />}
        </div>
      </div>
      {hasConnections ? <PushCalendars /> : null}
      <Route path={CALENDAR_CONNECTIONS_POPUP_ROUTE.rootPath} render={() => <CalendarAccountPopup isSettingsModalLayout={isSettingsModalLayout} />} />
    </div>;
};

require("./calendar_settings.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./calendar_settings.js");